const Services = (lang) => {
  return (
    <div className="services-container">
      <div className="services-wrapper">
        {lang?.lang?.services?.map((service) => (
          <article key={service.titre} className="services-article">
            <img
              src={`/images/services/argument-${service.icon}.svg`}
              alt={service.titre}
              width={65}
              height={65}
              loading="eager"
              fetchPriority="low"
            />
            <div className="content">
              <h2 suppressHydrationWarning>{service.titre}</h2>
              <p suppressHydrationWarning>{service.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Services;
